export class AccountState {
    isInitialized: boolean = false;

    name: string = '';
    email: string = '';
    subscribeToNewsletter: boolean = false;
    usersWorkspaceCount: number = 0;
    controlledDomainsCount: number = 0;
    hasPendingEmailAddressChange: boolean = false;
    requestedNewEmailAddress?: boolean = null;
    slackIsConnected: boolean = false;
    workspaceProperties: null = null;
    storymapProperties: null = null;
    theme: number = 0;

    apiToken: string = '';
    apiTokenGeneratedAt?: Date = null;

}
